<!--
================================================
Composant gérant le formulaire d'inscription / invitation
(Sur lequel l'utilisateur arrive en suivant le lien de l'email d'invitation)
================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div id="SignupInvitComp">
        <modal-terms-comp></modal-terms-comp>
        <div class="columns mainContainer" v-if="activationTokenIsValid">

            <div class="column"></div>
            <div class="column is-10 formColumn">

                <div class="columns">

                    <div class="column  columnContForm">
                        <form action="" v-on:keyup.enter="validateBeforeSubmit"  >

                            <router-link v-bind:to="{ name: 'home', params: {locale: $route.params.locale}}">
                                <img src="../assets/img/AppLogo.png" alt="Cronocloud App" width="164" height="29" class="logo">
                            </router-link>


                            <h1 >{{ $t("BienvenueSurCronocloud") }} 👋  </h1>
                            <p class="baseline">{{ $t("LeTempsCestPlusQueDeLArgent") }}...</p>



                            <div class="field">
                                <div class="control">
                                    <!-- sert au password manager du browser-->
                                    <input id="username4Manager" type="text" style="display:none" autocomplete="username" v-bind:value="email">
                                    <div class="invitedUserEmail">
                                        <label>{{$t('email')}}</label> :
                                        <span>{{email}}</span>
                                    </div>
                                </div>
                            </div>


                            <div class="field is-horizontal">

                                <div class="field-body">
                                    <div class="field">
                                        <div class="control">
                                            <input class="input" v-model="firstname" v-validate="'required|min:2|max:80'"
                                                   id="signup_firstname" name="signup_firstname" type="text"
                                                   autocomplete="given-name"
                                                   data-vv-delay="700"
                                                   v-bind:placeholder="$t('prénom')">
                                        </div>
                                        <p class="help is-danger has-text-left" id="error_signup_firstname">{{
                                            errors.first('signup_firstname') }}</p>
                                    </div>


                                    <div class="field">
                                        <div class="control">
                                            <input class="input" v-model="name" v-validate="'required|min:2|max:255'"
                                                   id="signup_name" name="signup_name" type="text"
                                                   data-vv-delay="700"
                                                   v-bind:placeholder="$t('nom')" autocomplete="family-name"
                                            >
                                        </div>
                                        <p class="help is-danger has-text-left" id="error_signup_name">{{
                                            errors.first('signup_name') }}</p>
                                    </div>

                                </div>

                            </div>


                            <div class="field has-addons">
                                <div class="control is-expanded">
                                    <input class="input"
                                           v-model="password" v-validate="'required|min:6|max:20'" id="signup_password"
                                           name="signup_password" v-bind:type="passwordFieldType"
                                           data-vv-delay="700"
                                           v-bind:placeholder="$t('motDePasse')" autocomplete="new-password">


                                </div>

                                <div class="control">
                                    <a id="switchPasswordReveal" class="button is-small is-right passwordReveal" v-on:click="toggleRevealPwd()" :title="passwordFieldType=='text' ? $t('masquerLeMotDePasse') : $t('afficherLeMotDePasse') " >
                                        <font-awesome-icon class="icon" v-if="passwordFieldType=='text'" :icon="['fas', 'eye-slash']"/>
                                        <font-awesome-icon class="icon" v-else :icon="['fas', 'eye']" />
                                    </a>
                                </div>

                            </div>
                            <p class="help is-danger has-text-left" id="error_signup_password">{{errors.first('signup_password') }}</p>

                            <div class="cgvLink">

                                <input type="checkbox" v-model="termsAccepted" v-validate="'required'" id="signup_cgv" name="signup_cgv">
                                <i18n path="jAccepteLes" tag="label" for="signup_cgv" class="checkbox">
                                    <a id="termsLink" v-on:click="openModalTerms()">{{ $t('conditionsDUtilisation') }}</a>
                                </i18n>
                                <p class="help is-danger has-text-centered" id="error_signup_cgv">{{errors.first('signup_cgv') }}</p>

                            </div>

                            <input type="hidden" name="locale" v-bind:value="locale">
                            <input type="hidden" name="timezone" v-bind:value="detectedTimezone">
                            <input type="hidden" name="currency" v-bind:value="currency">


                            <div class="field">
                                <a v-on:click="validateBeforeSubmit" id="formSubmitBtn" v-bind:class="{'is-loading':isSubmiting}" class="button  is-fullwidth signupBtn">{{$t("rejoindreLequipeX", {'name':organizationName} )}}</a>
                            </div>



                        </form>
                    </div>

                </div>


            </div>
            <div class="column"></div>


        </div>

    </div>
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import ModalTermsComp from "./ModalTermsComp";
    import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    import SentryMixin from "../mixins/SentryMixin.js";
    import InitialHydrationMixin from "../mixins/InitialHydrationMixin.js";
    import TimezoneMixin from "../mixins/TimezoneMixin.js";
    import MarketingAutomationMixin from "../mixins/MarketingAutomationMixin.js"
    import TrackingMixin from "@/mixins/TrackingMixin";

    export default {
        name: 'SignupInvitComp',
        components: {
            ModalTermsComp

        },
        mixins: [GlobalErrorNotification, SentryMixin, InitialHydrationMixin, TimezoneMixin, MarketingAutomationMixin, TrackingMixin ],
        data: function () {
            return {

                email: '',// string Email de l'user invité (récupéré lors de la validation du token)
                organizationName: '',// string Nom de l'organization de l'user invité (récupéré lors de la validation du token)
                activationToken: this.$route.params.token, // le d'invitation passé dans l'url
                activationTokenIsValid: false, // Boolean, indique si le token dans l'url a été validé par le backend
                passwordFieldType: 'password',// String | le type du champs passwork (password/text)

                // champs du formulaire
                name:'',
                firstname:'',
                password: '',
                termsAccepted:'',
                locale: this.$route.params.locale,      // {string} la locale récup. dans l'url
                isSubmiting: false ,     // indique si le formulaire est en cours de soumission
                detectedTimezone: null , // le timezone detecté
                currency: "EUR" , // la devise au format iso 4217 // @todo à dynamiser durant le ticket https://gitlab.com/ousmane1/kronocloud/-/issues/625
            }

        },

        methods: {

            toggleRevealPwd(){
                if(this.passwordFieldType=='password'){
                    this.passwordFieldType = 'text'
                }
                else if( this.passwordFieldType=='text') {
                    this.passwordFieldType = 'password'
                }

            },


            /*
            Envoi la requête pour réaliser l'inscription
            */
            sendSignupQuery(){
                let self = this

                return self.$http
                    .post("public/signup-invit", {
                        activationToken: self.activationToken,
                        name:self.name,
                        firstname:self.firstname,
                        plainPassword: self.password,
                        termsAccepted: self.termsAccepted,
                        locale: self.locale,
                        timezone: self.detectedTimezone,
                        currency: self.currency
                    })
                    .then(function (response) {
                      self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

                      // Authentification de l'user inscrit
                        self.$auth
                            .setToken(response.data.user_token)
                            .setRefreshToken(response.data.refresh_token)
                            .setOrganization(response.data.organization_slug)
                            .setRoles(response.data.user.roles)
                            .setUserSlug(response.data.user.slug)
                            .setWorkspaces(response.data.user.workspaces)
                            .setActiveWorkspace(response.data.user.workspaces[0].slug) // @todo à dynamiser lors de ticket #290 (https://gitlab.com/ousmane1/kronocloud/-/issues/290)
                            .setActiveWorkspaceCurrency(response.data.currency) // @todo voir si à dynamiser lors de ticket #290 (https://gitlab.com/ousmane1/kronocloud/-/issues/290)
                            .saveCookie();

                        // on récup. et stocke l' user l'organization dans le store
                        self.userInitialHydration(self)

                        // tracking mixpanel
                        self.$mixpanel.people.set({
                          "$distinct_id":response.data.user.slug,
                          "$email": self.email,
                          "$first_name": self.firstname,
                          "$last_name": self.name,
                          "$created":self.$moment().toISOString(),    // in ISO timestamp
                          "Organization":response.data.organization_slug,
                          'Last Login Date': self.$moment().toISOString(),
                        });
                        self.$mixpanel.alias(response.data.user.slug)
                        self.$mixpanel.track("signup (from invit)");

                        // enregistrement de l'évenement dans analytics
                        self.ga4GlobalEventTrack('Invitation sign up' , {})

                        // déclenchement mautic
                        self.replicateSignupInvit(self)

                        // redirection
                        self.$router.replace({
                            name: 'timeTracking',
                            params: {
                                locale: self.$route.params.locale,
                                organization: response.data.organization_slug
                            }
                        })

                    })
                    .catch(function (error) {
                        self.logToSentry(self, error, 'error')
                        let errorCode = '0013b'
                        self.showGlobalErrorNotif(self,errorCode)
                        self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error in signup invit query"})
                      self.$gtag.exception({'description': 'error '+errorCode + ' | error in signup invit', 'fatal': false})
                      self.$sentry.captureMessage(`Error ${errorCode} > error in signup invit query : ${error}`, 'error')
                    })
                    .then(() =>{
                        // toujours exécuté
                        this.isSubmiting = false;
                    })


            },

            /*
             * Valide le formulaire avant sa soumission
             */
            validateBeforeSubmit() {
                this.$store.commit('UpdateGlobalNotificationCompVisibility', false); // on masque un éventuel message à la soumission
                this.isSubmiting = true;

                let self = this
                this.$validator.validateAll().then((result) => {
                    if (result) { // si la validation. réussie
                        this.sendSignupQuery();
                    }
                    else{ // si il y a des erreurs...
                        self.$store.commit('UpdateGlobalNotificationComp', {
                            'isVisible': true,
                            'color': 'is-danger',
                            'message': self.$t('leFormulaireContientDesErreurs')
                        });
                        this.isSubmiting = false;
                    }

                })
            },


            /*
             Vérifie la validité du token dans l'url
             Cette méthode est basée sur la méthode éponyme dans VerifyAccountView
            */
                checkToken() {

            let self = this;

            return self.$http
                .post(`/public/account/verify?challengeOnly`, {
                        token: self.activationToken
                    },
                )
                .then(function (response) {
                  if (response.data.message == "token is valid") {
                        self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur
                        // validation ok on peut afficher la vue
                        self.activationTokenIsValid =true;
                        self.email =response.data.email;
                        self.organizationName= response.data.organizationName
                    }
                })
                .catch(function (error) {
                    self.activationTokenIsValid = false;
                    let errorCode = '0046'
                    self.$mixpanel.track('global error displayed', {"detail": "bad url token in signup-invit"})
                  self.$gtag.exception({'description': 'error '+errorCode + ' | bad url token in signup-invit', 'fatal': false})


                    if(error.response.status == 400 && error.response.data.message == 'account is already verified'){
                        self.$store.commit('UpdateGlobalNotificationComp', {
                            'isVisible': true,
                            'color': 'is-warning',
                            'message': self.$t('cetteInvitationNestPlusValide')
                        });
                    }
                    else if( // si token manquant ou incorrect
                        error.response.status == 400 &&  error.response.data.message == 'verification token is unknown'
                        || error.response.status == 400 &&  error.response.data.message == 'verification token is missing'
                    ){
                        self.$store.commit('UpdateGlobalNotificationComp', {
                            'isVisible': true,
                            'color': 'is-warning',
                            'message': self.$t('LeLienNestPasValide')
                        });
                    }
                    else{
                        let errorCode = '0021b'
                        self.showGlobalErrorNotif(self,errorCode)
                        self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error in verify account check token query (Signup invit)"})
                      self.$gtag.exception({'description': 'error '+errorCode + ' | error in verify account check token query (Signup invit)', 'fatal': false})
                        self.$sentry.captureMessage(`Error ${errorCode} > error in signup invit check token query : ${error}`, 'error')
                    }
                })
        }


            /*
             Affiche la modalTerms
             */
            ,openModalTerms() {
                this.$store.commit('UpdateModalTermsComp', {'isVisible': true})
            },


        },

        computed: mapState({}),

        created: function () {

        },
        mounted: function () {
            this.detectedTimezone = this.detectTimezone()
            this.checkToken()

        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";
    @import "../assets/css/bulmaResponsiveDep.scss";

    .column {
        /*border: dashed 1px #ccc;*/
    }

    .mainContainer {
        @include mobile {
            padding: 0 1.5rem;
            margin-top: -1.5rem;
        }
    }

    .formColumn {
        padding: 2rem 1rem;
        background: #f3f3f3;
        border-radius: 3px;

        .logo{
            margin: 1rem auto 2rem;
            display: block;
        }
        h1 {
            font-weight: bold;
            color: $brandThird;
            font-size: 1.6rem !important;
        }

        .baseline{
            margin: 0.5rem 0 3rem;
            font-size: 0.95rem;
            text-transform: uppercase;
            color:$brandFourth;
            border-bottom: solid 1px lighten($brandFourth,30%);
            padding-bottom: 2rem;


        }

        .field {
            margin-bottom: 2rem;
        }
        .is-horizontal, .has-addons{
            margin-bottom: 0;//reset
        }
        .help{
            min-height: 1.3rem;
            @include touch{
                min-height: 0;
            }
        }
        .signupBtn {
            padding: 2rem 0;
            border: solid 1px transparent;
            background: $brandPrimary;
            font-weight: bold;
            text-transform: uppercase;
            color: white;
            &:hover {
                transition: background-color 0.3s;
                background: lighten($brandPrimary, 5%);
                color: white;
            }
            &:active {
                background: $brandThird;
                transition: background-color 0.1s;
                color: white;
            }

        }

        .columnContForm {
            padding: 0 4.5rem;

            @include mobile {
                padding: 0 1rem;
            }
            .passwordReveal{
                display: block;
                margin: 0.5rem 0.2rem 0 0.5rem;
                font-size: 1rem;
                background: transparent;
                color: $brandFourth;
                border: none;
                .icon{
                    display: block;
                }
            }
        }

        .invitedUserEmail{
            font-size: 1.1rem;
            font-weight: bold;
            color: $brandFourth;
            text-transform: lowercase;
        }

        .cgvLink {
            margin: 2rem 0;
            $color: #839ba6;
            color: $color;
            label{
                color:$color;
            }
            a {
                color: $color;
                text-decoration: underline

            }
        }

    }

</style>
